// extracted by mini-css-extract-plugin
module.exports = {"root":"StaffCell_root__2mjRR","pic":"StaffCell_pic__3ooDG","name":"StaffCell_name__UIbQg","team":"StaffCell_team__11-wc"};